import vars from '../helpers';


$('.page.article').on('scroll', (e) => {
	const $article = $(e.currentTarget);

	const $head = $article.find('.article__head');

	if ($article.scrollTop() > $head.outerHeight() - parseInt($head.css('padding-bottom'), 10)) {
		vars.$html.addClass('is-burger-mix');
	} else {
		vars.$html.removeClass('is-burger-mix');
	}
})
